import SignatureCanvas from 'react-signature-canvas';
import { PenTool, Check } from 'lucide-react';

interface SignatureModalProps {
  isOpen: boolean;
  isDelegateMode: boolean;
  targetEmployeeName: string;
  saving: boolean;
  sigCanvasRef: React.RefObject<SignatureCanvas | null>;
  onClear: () => void;
  onCancel: () => void;
  onValidate: () => void;
}

export function SignatureModal({
  isOpen,
  isDelegateMode,
  targetEmployeeName,
  saving,
  sigCanvasRef,
  onClear,
  onCancel,
  onValidate,
}: SignatureModalProps) {
  if (!isOpen) return null;

  return (
    <div style={{ position: 'fixed', top: 0, left: 0, right: 0, bottom: 0, backgroundColor: 'rgba(15, 23, 42, 0.7)', backdropFilter:'blur(5px)', zIndex: 1000, display: 'flex', justifyContent: 'center', alignItems: 'center', animation:'fadeIn 0.2s' }}>
      <div style={{ background: 'white', padding: '40px', borderRadius: '24px', width: '90%', maxWidth: '550px', display: 'flex', flexDirection: 'column', gap: '24px', boxShadow:'0 25px 50px -12px rgba(0, 0, 0, 0.25)' }}>
        <div>
          <h3 style={{ margin: '0 0 8px 0', color:'#1e293b', fontSize:'1.5rem', display:'flex', alignItems:'center', gap:'12px' }}>
            <PenTool size={28} />
            {isDelegateMode ? `Validation Responsable` : "Signature Employé"}
          </h3>
          <p style={{ margin: 0, color: '#64748b', fontSize: '1rem' }}>
            {isDelegateMode ? `Pour le compte de : ${targetEmployeeName}` : "Je certifie l'exactitude des heures saisies."}
          </p>
        </div>

        <div style={{ border: '2px dashed #cbd5e1', borderRadius: '16px', height: '250px', position: 'relative', background:'#f8fafc' }}>
          <SignatureCanvas ref={sigCanvasRef} penColor='black' canvasProps={{ style: { width: '100%', height: '100%' }, className: 'sigCanvas' }} />
          <button onClick={onClear} style={{ position: 'absolute', top: '12px', right: '12px', background: 'white', border: '1px solid #e2e8f0', borderRadius: '8px', padding: '6px 12px', fontSize: '0.85rem', cursor: 'pointer', color:'#64748b', fontWeight:'600' }}>Effacer</button>
        </div>

        <div style={{ display: 'flex', gap: '16px', marginTop: '10px' }}>
          <button onClick={onCancel} style={{ flex: 1, padding: '16px', background: 'white', border: '1px solid #cbd5e1', borderRadius: '14px', cursor: 'pointer', fontWeight:'600', color:'#475569', fontSize:'1.1rem' }}>Annuler</button>
          <button onClick={onValidate} style={{ flex: 1, padding: '16px', background: '#10b981', color: 'white', border: 'none', borderRadius: '14px', fontWeight: 'bold', cursor: 'pointer', boxShadow:'0 4px 6px rgba(16, 185, 129, 0.2)', display:'flex', alignItems:'center', justifyContent:'center', gap:'10px', fontSize:'1.1rem' }}>
            <Check size={24} />
            {saving ? 'Traitement...' : 'Valider'}
          </button>
        </div>
      </div>
    </div>
  );
}
